import React from 'react';

import { Box, Typography } from '@mui/material';

import { ShowFnOutput } from 'mui-modal-provider';

import { VennueAccessRequestItem, VenueAccessREnum } from '../../../../graphql/API';
import { venueActionAccessRequestApi } from '../../../../api/accessRequest/venueActionAccessRequestApi';
import LoadingButton from '../../../Button/LoadingButton';
import BaseDialog, { BaseDialogProps } from '../../Base';

type UndoConfirmDialogProps = {
  row: VennueAccessRequestItem;
  modalRef: React.MutableRefObject<ShowFnOutput<BaseDialogProps> | undefined>;
  onSuccess?: () => void;
} & BaseDialogProps;

export const UndoConfirmDialog: React.FC<UndoConfirmDialogProps> = ({
  row,
  modalRef,
  onSuccess,
  onClose,
  ...restProps
}) => {
  const [loading, setLoading] = React.useState(false);

  const userName =
    `${row.user?.firstname || ''} ${row.user?.lastname || ''}`.trim() || 'this user';
  const productName = row.offer?.title || 'this product';

  const handleConfirm = React.useCallback(async () => {
    if (!row.userID || !row.offerID) return;

    setLoading(true);
    try {
      await venueActionAccessRequestApi({
        action: VenueAccessREnum.requested,
        userID: row.userID,
        offerID: row.offerID,
      });
      onSuccess?.();
      modalRef.current?.destroy();
    } catch (error) {
      console.error('Error undoing access request:', error);
    } finally {
      setLoading(false);
    }
  }, [row.userID, row.offerID, modalRef, onSuccess]);

  const handleCancel = React.useCallback(() => {
    modalRef.current?.destroy();
    onClose?.({}, 'backdropClick');
  }, [modalRef, onClose]);

  return (
    <BaseDialog
      width="550px"
      height="250px"
      titleComponent={<></>}
      showCloseIcon={false}
      onClose={onClose}
      {...restProps}
    >
      <Box>
        <Typography textAlign="center" fontSize="18px" fontWeight={500}>
          Confirm Undo
        </Typography>
        <Typography paddingTop="34px" textAlign="center">
          Are you sure you want to set the request from {userName} for {productName} back to
          pending?
        </Typography>

        <Box display="flex" alignItems="center" gap="20px" mt={4}>
          <LoadingButton
            fullWidth
            variant="outlined"
            size="large"
            sx={{ paddingY: '12px' }}
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </LoadingButton>
          <LoadingButton
            fullWidth
            loading={loading}
            variant="contained"
            size="large"
            sx={{ paddingY: '12px' }}
            onClick={handleConfirm}
          >
            Confirm
          </LoadingButton>
        </Box>
      </Box>
    </BaseDialog>
  );
};
